import { render } from "./shipping.vue?vue&type=template&id=2ca767cc&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"

import "./shipping.vue?vue&type=style&index=0&id=2ca767cc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca767cc"]])

export default __exports__